export default "__VITE_ASSET__Cm1oPqz2__"